import { GetStaticProps } from 'next';
import React, { useEffect } from 'react';
import AlliedServicesComponent from '../../components/AlliedServicesComponent';
import ErrorComponent from '../../components/ErrorComponent';
import { MetaTagsComp } from '../../components/MetaTagsComp';
import fetchUtil from '../../utils/fetchUtil';
import { CACHE_REVALIDATE_24H } from '../../utils/constants';

const AlliedServices: React.FC = (props: any) => {
  const { meta } = props?.pageDataLanding
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#6C48F0');
    customStyle.setProperty('--navbar-menu-color', '#ffffff')
  }, [])
  if (!props.pageData || props.pageData.length === 0) {
    return <ErrorComponent />
  }
  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
      <AlliedServicesComponent {...props} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/allied-services/cards`, 'GET', {}, '', false)
  const pageDataLanding = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/allied-services-landing`, 'GET', {}, '', false)
  return {
    props: { pageData, pageDataLanding },
    revalidate: CACHE_REVALIDATE_24H,
  };
}

export default AlliedServices;